/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function pay(params, context) {
    var _a;
    // https://open.dingtalk.com/document/orgapp/payment-interface
    var api = 'dd.biz.alipay.pay';
    (_a = context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, params, {
        formatInput: function (input) {
            return { info: input.payStr }; // 订单信息
        },
    });
}

export { pay as default };
